"use strict";import r from"./_merge.js";const e=function(n,t){return r(!0,!1,...arguments)};export default e;
//# sourceMappingURL=merge.js.map
